<template>
<svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   version="1.1"
   x="0px"
   y="0px"
   viewBox="0 0 59.199219 63"
   enable-background="new 0 0 65 65"
   xml:space="preserve"
   id="svg3450"
   width="59.199219"
   height="63"><g
     transform="translate(-2.4003906,-2.4126584)"
     id="g1140"><polygon
       points="38.9,29.1 42.5,32.5 38.9,35.9 39.9,37 44.7,32.5 39.9,28 "
       id="polygon3454"
       transform="matrix(1.8109574,0,0,1.7198512,-27.576525,-10.734885)" /><polygon
       points="27,28 22.2,32.5 27,37 28,35.9 24.3,32.5 28,29.1 "
       id="polygon3456"
       transform="matrix(1.8109574,0,0,1.7198512,-27.576525,-10.734885)" /><rect
       x="11.504788"
       y="-51.413319"
       transform="matrix(-0.46178089,0.88699403,-0.90518094,-0.42502642,0,0)"
       width="30.764179"
       height="2.6900845"
       id="rect3458"
       style="stroke-width:1.76552296" /></g><path
     id="path3460"
     d="m 6.5996094,1 c -1.5,0 -2.9,0.4996094 -4,1.5996094 -1,1.1 -1.5996094,2.5 -1.5996094,4 V 8.900391 l 0.099609,9.298828 v 38.201172 c 0,1.5 0.4996094,2.9 1.5996094,4 1.1,1 2.5,1.599609 4,1.599609 H 8.4003902 50.798828 52.5 c 1.5,0 2.9,-0.599609 4,-1.599609 1.1,-1.1 1.599609,-2.5 1.599609,-4 V 18.199219 l 0.09961,-9.298828 V 6.5996094 c 0,-1.5 -0.599609,-2.9 -1.599609,-4 C 55.499609,1.4996094 54.099609,1 52.599609,1 H 50.798828 8.4003902 Z m 0.099609,1.5 H 8.4003902 50.798828 52.5 c 1.1,0 2.160631,0.4594595 2.90039,1.1992188 0.739759,0.7397594 1.199219,1.5878178 1.199219,2.9003906 V 9 18.199219 56 c 0,1.1 -0.399219,2.100392 -1.199219,2.900391 -0.8,0.8 -1.80039,1.199218 -2.90039,1.199218 H 50.798828 8.4003902 6.6992188 c -1.1,0 -2.1003904,-0.399218 -2.9003906,-1.199218 C 2.9988281,58.100391 2.5996094,57.1 2.5996094,56 V 18.199219 9 6.5996094 c 0,-1.1 0.4992187,-2.2003906 1.1992188,-2.9003906 C 4.5988283,2.8992187 5.5992188,2.5 6.6992184,2.5 Z" /><g
     transform="translate(-2.4003896,-2.4126584)"
     id="g1135"><rect
       x="12.670971"
       y="23.208244"
       width="40.658058"
       height="2.4821248"
       id="rect3462"
       style="stroke-width:1.65712953" /><rect
       x="12.670971"
       y="15.761871"
       width="32.692398"
       height="2.4821248"
       id="rect3464"
       style="stroke-width:1.65712953" /><rect
       x="12.670971"
       y="8.4809761"
       width="21.573664"
       height="2.4821248"
       id="rect3466"
       style="stroke-width:1.65712953" /></g></svg>
</template>
